export const order = {
  ALL: 'All',
  LIST: 'List',
  COMPACT: 'Compact',
  ORDER: 'Order',
  ORDER_LIST: 'Order List',
  VIEW: 'View',
  'More options for': 'More options for',
};
